// alternative-dashboard\alternative-components\CFOCopilot\InfoCard.tsx
import React from "react";
import "./styles/CustomeChart.scss";

interface InfoCardProps {
  title: string;
  color: string;
  headline: string;
  description: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  color,
  headline,
  description,
}) => {
  return (
    <div className="gx-info-card" style={{ borderLeft: `4px solid ${color}` }}>
      <div className="gx-info-card__body">
        <span className="gx-info-card__title gx-p16-sb" style={{ color }}>
          {title}
        </span>
        <h6 className="gx-info-card__headline gx-p16-b">{headline}</h6>
        <p className="gx-info-card__description gx-p14-md">{description}</p>
      </div>
    </div>
  );
};

export default InfoCard;
